import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../CartContext';
import { AuthContext } from '../contexts/AuthContext';
import './Navbar.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [userName, setUserName] = useState('');
  const [userRole, setUserRole] = useState('');
  /* eslint-disable no-unused-vars */
  const { cartCount } = useCart();
  const { isAuthenticated, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    document.body.classList.toggle('menu-open', !isOpen);
  };

  useEffect(() => {
    return () => {
      document.body.classList.remove('menu-open');
    };
  }, []);

  useEffect(() => {
    console.log("🔍 Navbar - isAuthenticated:", isAuthenticated);
    
    if (isAuthenticated) {
      const name = localStorage.getItem("userName");
      const role = localStorage.getItem("userRole");
      
      console.log("📝 userName from localStorage:", name);
      console.log("📝 userRole from localStorage:", role);
      
      if (name) {
        setUserName(name);
      }
      if (role) {
        setUserRole(role);
      }
    } else {
      setUserName('');
      setUserRole('');
    }
  }, [isAuthenticated]);

  const handleLogout = () => {
    logout();
    localStorage.removeItem("token");
    localStorage.removeItem("userName");
    localStorage.removeItem("userRole");
    setShowDropdown(false);
    setIsOpen(false);
    navigate("/");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showDropdown && !event.target.closest('.user-menu')) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showDropdown]);

  console.log("🎨 Rendu Navbar - isAuthenticated:", isAuthenticated, "userName:", userName);

  return (
    <nav className="navbar">
      <div className="logo">TSE Consultant INT</div>

      <div className={`nav-links ${isOpen ? 'open' : ''}`}>
        <Link to="/" onClick={() => setIsOpen(false)}>Accueil</Link>
        <Link to="/services" onClick={() => setIsOpen(false)}>Services</Link>
        <Link to="/ServicesStagiaires" onClick={() => setIsOpen(false)}>Services Stagiaires</Link>
        <Link to="/products" onClick={() => setIsOpen(false)}>Produits</Link>
        <Link to="/contact" onClick={() => setIsOpen(false)}>Contact</Link>
      </div>
      
      <div className="auth-container">
        {isAuthenticated ? (
          <div className="user-menu">
            <button 
              className="user-btn"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <i className="fas fa-user-circle"></i>
              <span className="user-name">{userName || 'Utilisateur'}</span>
              <i className={`fas fa-chevron-down ${showDropdown ? 'rotate' : ''}`}></i>
            </button>

            {showDropdown && (
              <div className="dropdown-menu">
                <div className="dropdown-header">
                  <i className="fas fa-user-circle"></i>
                  <div>
                    <p className="dropdown-user-name">{userName || 'Utilisateur'}</p>
                    <p className="dropdown-user-role">{userRole || 'User'}</p>
                  </div>
                </div>
                
                <hr className="dropdown-divider" />
                
                <Link 
                  to="/profile" 
                  className="dropdown-item"
                  onClick={() => {
                    setShowDropdown(false);
                    setIsOpen(false);
                  }}
                >
                  <i className="fas fa-user"></i>
                  Mon profil
                </Link>
                
                {userRole?.toLowerCase() === 'admin' && (
                  <Link 
                    to="/admin/dashboard" 
                    className="dropdown-item"
                    onClick={() => {
                      setShowDropdown(false);
                      setIsOpen(false);
                    }}
                  >
                    <i className="fas fa-tachometer-alt"></i>
                    Dashboard Admin
                  </Link>
                )}
                
                <Link 
                  to="/orders" 
                  className="dropdown-item"
                  onClick={() => {
                    setShowDropdown(false);
                    setIsOpen(false);
                  }}
                >
                  <i className="fas fa-shopping-bag"></i>
                  Mes commandes
                </Link>
                
                <Link 
                  to="/settings" 
                  className="dropdown-item"
                  onClick={() => {
                    setShowDropdown(false);
                    setIsOpen(false);
                  }}
                >
                  <i className="fas fa-cog"></i>
                  Paramètres
                </Link>
                
                <hr className="dropdown-divider" />
                
                <button 
                  onClick={handleLogout} 
                  className="dropdown-item logout-item"
                >
                  <i className="fas fa-sign-out-alt"></i>
                  Déconnexion
                </button>
              </div>
            )}
          </div>
        ) : (
          <Link to="/login" className="login-link">
            <i className="fas fa-sign-in-alt"></i>
            Connexion
          </Link>
        )}
      </div>

      <div className="menu-toggle" onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
    </nav>
  );
};

export default Navbar;